import "./JunkRemovalStittsville.module.css";
import Header from "@/reusable_sections/Header";
import HeroStittsville from "./sections/HeroStittsville";
import IntroductionStittsvilleLocal from "./sections/IntroductionStittsvilleLocal";
import ServicesGrid from "./sections/ServicesGrid";
import WhyChooseUs from "./sections/WhyChooseUs";
import HowItWorks from "./sections/HowItWorks";
import BeforeAfterGallery from "./sections/BeforeAfterGallery";
import FaqStittsville from "./sections/FaqStittsville";
import FinalCtaStittsville from "./sections/FinalCtaStittsville";
import Footer from "@/reusable_sections/Footer";
export default function JunkRemovalStittsvillePage() {
  return <div>
      <Header />
      <HeroStittsville />
      <IntroductionStittsvilleLocal />
      <ServicesGrid />
      <WhyChooseUs />
      <HowItWorks />
      <BeforeAfterGallery />
      <FaqStittsville />
      <FinalCtaStittsville />
      <Footer />
    </div>;
}